import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../Context/Auth'; // تأكد من المسار
import { useCart } from '../../components/Context/Cart'; // استيراد الكونتكست بتاع السلة

export default function Navbar() {
  const { isLoggedIn, logout } = useAuth();
  const { cartItems } = useCart(); // استدعاء منتجات السلة
  const navigate = useNavigate();

  // حساب العدد الإجمالي للمنتجات في السلة
  const totalQuantity = cartItems.reduce((acc, item) => acc + item.quantity, 0);

  if (!isLoggedIn) return null;

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar navbar-expand-lg bg-light fixed-top">
      <div className="container">
        <Link className="navbar-brand fw-bold" to="/home">React Ecommerce</Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-between" id="navbarNavDropdown">
          <ul className="navbar-nav mx-auto">
            <li className="nav-item"><Link className="nav-link" to="/home">Home</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/products">Products</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/about">About</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/contact">Contact</Link></li>
          </ul>
          <div className="d-flex gap-2">
            <button onClick={handleLogout} className="btn btn-outline-dark">
              <i className="fa fa-sign-out me-1"></i> Logout
            </button>
            <Link className="btn btn-outline-dark" to="/profile">
              <i className="fa fa-user me-1"></i> Profile
            </Link>
            <Link to="/cart">
              <button className="btn btn-outline-dark">
                <i className="fa fa-shopping-cart me-1"></i> Cart ({totalQuantity})
              </button>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
